import {
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

export type DataColumn<T> = {
  key: keyof T;
  label: string;
  render?: (value: T[keyof T] | null, row: T) => React.ReactNode;
};

export type ActionColumn<T> = {
  key: "actions";
  label: string;
  render: (value: null, row: T) => React.ReactNode;
};

export type Column<T> = DataColumn<T> | ActionColumn<T>;

interface ResponsiveTableProps<T> {
  columns: Column<T>[];
  data: T[];
}

function isActionColumn<T>(col: Column<T>): col is ActionColumn<T> {
  return col.key === "actions";
}

export default function ResponsiveTable<T>({
  columns,
  data,
}: ResponsiveTableProps<T>) {
  return (
    <div className="w-full">
      {/* Tabla para escritorio */}
      <div className="hidden md:block">
        <Table className="w-full text-sm">
          <TableHeader>
            <TableRow className="bg-gray-50 dark:bg-gray-900/20">
              {columns.map((col, colIdx) => (
                <TableCell
                  key={`${String(col.key)}-${colIdx}`}
                  isHeader
                  className="py-4 px-4 font-semibold text-gray-600 dark:text-gray-300 text-left"
                >
                  {col.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHeader>

          <TableBody>
            {data.map((row, idx) => (
              <TableRow
                key={idx}
                className="hover:bg-gray-50 dark:hover:bg-gray-900/30 transition-colors"
              >
                {columns.map((col, colIdx) => (
                  <TableCell
                    key={`${String(col.key)}-${colIdx}-${idx}`}
                    className="py-4 px-4 text-gray-800 dark:text-gray-300"
                  >
                    {isActionColumn(col)
                      ? col.render(null, row)
                      : col.render
                      ? col.render(row[col.key], row)
                      : (row[col.key] as any)}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>

      {/* Cards para movil opcion 1 */}
      {/* <div className="md:hidden flex flex-col gap-4">
        {data.map((row, idx) => (
          <div
            key={idx}
            className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm dark:border-gray-800 dark:bg-white/[0.06]"
          >
            {columns.map((col) => (
              <div key={`${String(col.key)}-${idx}`} className="mb-3 last:mb-0">
                <p className="text-xs font-semibold text-gray-500 dark:text-gray-400">
                  {col.label}
                </p>

                <p className="text-sm font-medium text-gray-800 dark:text-gray-200 mt-1">
                  {isActionColumn(col)
                    ? col.render(null, row)
                    : col.render
                    ? col.render(row[col.key], row)
                    : (row[col.key] as any)}
                </p>
              </div>
            ))}
          </div>
        ))}
      </div> */}

      {/* Cards para movil opcion 2 */}
      <div className="md:hidden flex flex-col gap-4">
        {data.map((row, idx) => (
          <div
            key={idx}
            className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm dark:border-gray-800 dark:bg-white/[0.06]"
          >
            {columns.map((col, colIdx) => (
              <div
                key={`${String(col.key)}-${colIdx}-${idx}`}
                className="mb-3 last:mb-0 flex justify-between items-center gap-3"
              >
                <span className="text-xs font-semibold text-gray-500 dark:text-gray-400 w-1/3">
                  {col.label}
                </span>

                <span className="text-sm font-medium text-gray-800 dark:text-gray-200 w-2/3 text-right">
                  {isActionColumn(col) ? (
                    <div className="flex justify-end">
                      {col.render(null, row)}
                    </div>
                  ) : col.render ? (
                    col.render(row[col.key], row)
                  ) : (
                    (row[col.key] as any)
                  )}
                </span>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
